<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 2.16667C5.5 1.24619 6.24619 0.5 7.16667 0.5H11.6111C12.5316 0.5 13.2778 1.24619 13.2778 2.16667V17.1667H5.5V2.16667Z"
      :stroke="color"
    />
    <path
      d="M16.6146 8.83464C16.6146 7.91416 15.8684 7.16797 14.9479 7.16797H13.2812V17.168H16.6146V8.83464Z"
      :stroke="color"
    />
    <path
      d="M1.05469 12.1667C1.05469 11.2462 1.80088 10.5 2.72135 10.5H5.49913V17.1667H1.05469V12.1667Z"
      :stroke="color"
    />
    <path d="M8.28125 7.16797H10.5035" :stroke="color" stroke-linecap="round" />
    <path d="M8.28125 10.5H10.5035" :stroke="color" stroke-linecap="round" />
    <path d="M8.28125 3.83398H10.5035" :stroke="color" stroke-linecap="round" />
    <path d="M17.1667 17.168H0.5" :stroke="color" stroke-linecap="round" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
